import React from 'react';
import { Link } from 'react-router-dom';
import Thumb from './Thumb';
import RightSide from './RightSide';
import BreadCrumb from '../BreadCrumb';
import Content from '../Content';
import Share from './Share';


const Post = ({ post, recentPosts, comments, archieves, categories, tags, crumbs, items  }) => (
  <section className="section blog-section section-light-grey">
      <div className="container">
          <div className="columns">
            <div className="column-is-12">
            {
              crumbs.length > 0
                ? <BreadCrumb crumbs={crumbs} extraClass="pl-10 pt-10 pb-10" />
                : ''
            }
            </div>
          </div>
          <div className="columns">
              <div className="column is-8">
                  <div className="flex-card is-full-post has-sidebar light-bordered">
                      <div className="post-meta content">
                          <img className="author-avatar is-hidden-mobile" src="https://via.placeholder.com/250x250" alt="" data-demo-src="assets/images/agency/avatars/marc.jpg" />
                          <div className="title-block">
                              <h2>{post.title}</h2>
                              <h4>{post.subtitle}</h4>

                              <button className="like fab-btn mini is-single" data-toggle="tooltip" data-placement="left" data-title={`${post.likeCount} kişi tarafından beğenildi`} data-original-title="">
                                  <span className="like-wrapper">
                                          <i className="material-icons unliked">favorite_border</i>
                                          <i className="material-icons liked">favorite</i>
                                          <span className="like-overlay"></span>
                                  </span>
                              </button>
                          </div>
                      </div>

                      <div className="post-body content">
                          <div className="author-name">Hazırlayan <b><a href="#">{post.author}</a></b>, <span>{post.authorTitle}</span></div>
                          <div className="timestamp"><i className="sl sl-icon-clock"></i>{post.timeStamp}</div>


                          <Content items={items} />

                          <Share title={post.title} shareUrl={post.shareUrl} />
                      </div>
                  </div>
              </div>

              <RightSide
                recentPosts={recentPosts}
                comments={comments}
                archieves={archieves}
                categories={categories}
                tags={tags}
              />
          </div>
      </div>
  </section>
);

export default Post;
